<template>
	<div class="tagbox">
		<div v-if="data.label||data.alt"
			 :class="data.inline?'box-title2':'box-title1'">
			{{ data.inline && data.alt ? data.alt : data.label }}
		</div>
		<component v-if="isTreeSelectLoaded && data.selectbox"
			    is="treeselect"
				v-model="treeval"
				:key="data.id+'_'+componentKey"
				:options="data.children"
				:placeholder="placeholder"
				:disable-branch-nodes="true"
				:multiple="true"
		/>
		<tags-expanded
				v-else-if="data.expand"
				v-for="(tag, idx) in data.children"
				:key="tag.id+'_'+idx+'_'+componentKey"
				:data="tag"
		/>
		<div v-else>
			<div class="tagbox">
				<div v-for="(tag, idx) in data.children"
					 :key="tag.id+'_'+idx+'_'+componentKey"
					 :class="{'selected':tag.selected}"
					 @click="toggleItem(tag)"
					 class="chip">{{ tag.label }}</div>
			</div>
			<component v-for="(tag,idx) in tagBoxes"
					   is="Tags"
					   :key="tag.id+'_'+idx+'_'+componentKey"
					   :data="tag"
			/>
		</div>
	</div>
</template>
<script>
	import TagsExpanded from "@/components/Tags/TagsExpanded.vue";
	import mixins from "@/components/Tags/mixins";

	export default {
		name: 'Tags',
		mixins: [ mixins ],
		components: { TagsExpanded },
		//
		props: {
			data: { type: Object, default() { return {} } },
		},
		//
		data() {
			return {
				isTreeSelectLoaded: ('treeselect' in Vue.options.components),
				placeholder: 'В этом поле можно искать',
				componentKey: 1,
				tagBoxes: {},
				treeval: null,
			}
		},
		//
		created() {
			if (this.data.selectbox) {
				this.treeval = this.setSelectedTagInTagbox(this.data.children);
				return;
			}

			for (let k in this.data.children) {
				if (!this.data.children.hasOwnProperty(k)) continue;
				if (this.data.expand) continue;
				if (this.data.children[k].selected) {
					this.selectItem(this.data.children[k]);
				}
			}
		},
		//
		methods: {
			setSelectedTagInTagbox(children, a = []) {
				for (let k in children) {
					if (!children.hasOwnProperty(k)) continue;
					if (children[k].selected) a.push(children[k].id);
					if (children[k].children) {
						this.setSelectedTagInTagbox(children[k].children, a)
					}
					children[k].selected = false;
				}
				return a
			},
			toggleItem(tag) {
				if (!tag.selected && this.onlyOne) {
					if (!this.data.expand) this.uncheckAll();
				}
				tag.selected = !tag.selected;
				if (this.isDir(tag)) {
					if (tag.selected) {
						this.tagBoxes[tag.id] = tag;
					} else {
						this.unselectAllChilds();
						this.resetAllChilds(tag.children);
					}
				}
			},
			uncheckAll() {
				this.unselectAllChilds();
				if (!Array.isArray(this.data.children)) return;
				for (let k in this.data.children) {
					if (!this.data.children.hasOwnProperty(k)) continue;
					this.data.children[k].selected = false;
					this.resetAllChilds(this.data.children[k].children);
				}
			},
			unselectAllChilds() {
				if (this.$children) {
					for (let k in this.$children) {
						if (!this.$children.hasOwnProperty(k)) continue;
						this.$children[k].treeval = null;
						for (let k1 in this.$children[k].tagBoxes) {
							if (!this.$children[k].tagBoxes.hasOwnProperty(k1)) continue;
							this.$children[k].tagBoxes[k1].selected = false;
							delete this.$children[k].tagBoxes[k1];
						}
					}
				}
				for (let k in this.tagBoxes) {
					if (!this.tagBoxes.hasOwnProperty(k)) continue;
					this.tagBoxes[k].selected = false;
					delete this.tagBoxes[k];
				}
			},
			resetAllChilds(children) {
				if (!Array.isArray(children)) return;
				for (let k in children) {
					if (!children.hasOwnProperty(k)) continue;
					children[k].selected = false;
					if (Array.isArray(children[k].children)) {
						this.resetAllChilds(children[k].children);
					}
				}
			},
		},
	}
</script>
